import * as moment from "moment";

export class RecruitUserPreference {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.appUserID = json && json.app_user_id || null;
        this.preferenceID = json && json.preference_option_id || 0
        this.preferenceTypeID = json && json.preference_type_id || 0
    }

    id: number;
    appUserID: number;
    preferenceID: number;
    preferenceTypeID: number;

    toJSON() {
        return {
            id: this.id,
            app_user_id: this.appUserID,
            preference_option_id: this.preferenceID,
            preference_type_id: this.preferenceTypeID
        }
    }
}

